import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import * as Utils from '../../services/utils';

function CmpsModifyAppointment({onScroll,onShowInput}) {
  const [typing, setTyping] = useState(true);

  const pushDataLayer = () => {
    Utils.eventsDataLayer('chatbot_cta', 'Modifica appuntamento');
  }

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/appuntamento-programmato');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <section id="cmps-modifica-appuntamento">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <>
          <div className="messages messages--receiver">
            <div className="message">
              <CmpsAnimation wait={300}>
                <span className="bubble">Sembra che tu abbia già un<br /> appuntamento programmato!</span>
              </CmpsAnimation>
              <CmpsAnimation wait={600}>
                <span className="bubble">Se desideri modificare<br /> l'appuntamento già fissato, vai alla<br /> pagina dedicata o clicca sul bottone<br /> sotto</span>
              </CmpsAnimation>
              <CmpsAnimation wait={900} last={true}>
                <span className="bubble">Grazie e a presto!</span>
                <div className="info">
                  <span className="time"><Timestamp /></span>
                </div>
              </CmpsAnimation>
            </div>
          </div>
          <CmpsAnimation wait={1200}>
            <Button htmlType="submit" onClick={pushDataLayer} className={['cmps_btn', 'cmps_btn__redirect']}>
            MODIFICA APPUNTAMENTO
            </Button>
          </CmpsAnimation>
        </>
      )}
    </section>
  );
  
} 

export default CmpsModifyAppointment;